<template>
  <div>
    <v-select
      @change="handleCustomerSelect"
      item-text="name"
      item-value="id"
      :items="customers"
      :value="value"
      :label="label"
      :rules="rules"
      return-object
      outlined
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'CustomerSelect',

  props: {
    value: {
      type: String,
      default: '',
    },

    label: {
      type: String,
    },

    rules: {
      type: Array,
    },

    customers: {
      type: Array,
      required: true,
    },
  },

  computed: {
    isServiceProviderUser() {
      const userRole = localStorage.getItem('access_roles')
      return userRole.includes('ROLE_SERVICE_PROVIDER')
    },
  },

  data() {
    return {
      isLoading: true,
    }
  },

  methods: {
    ...mapActions(['listServiceProviderCustomers']),
    ...mapMutations([
      'setAppointmentFields',
      'setAppointmentCreationConfirmToClose',
    ]),

    handleCustomerSelect(customer) {
      this.setAppointmentCreationConfirmToClose(true)
      this.setAppointmentFields({ real_estate_id: customer?.id })
      this.setAppointmentFields({ real_estate_branch_id: null })
      this.setAppointmentFields({ real_estate_branch_name: null })
      this.setAppointmentFields({ type: null })
    },

    initCustomers() {
      if (!this.isServiceProviderUser) return

      this.listServiceProviderCustomers().finally(() => {
        this.isLoading = false
      })
    },
  },

  mounted() {
    this.initCustomers()
  },
}
</script>
